// API isolada do APP DO ENTREGADOR — token próprio (mot_token), sem interferir
// na sessão do ERP. 401 manda pro login do entregador, não pro /login do ERP.
import axios from 'axios'
import toast from 'react-hot-toast'

export const motApi = axios.create({
  baseURL: (import.meta.env.VITE_API_URL || '/api') + '/motorista-app',
  timeout: 30000,
})

motApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('mot_token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

motApi.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status
    const detail = err.response?.data?.detail || err.message
    if (status === 401) {
      localStorage.removeItem('mot_token')
      localStorage.removeItem('mot_info')
      if (!window.location.pathname.endsWith('/m/entregador')) {
        window.location.href = '/m/entregador'
      }
    } else if (status >= 400) {
      toast.error(typeof detail === 'string' ? detail : 'Erro na requisição')
    }
    return Promise.reject(err)
  },
)

export function getMotInfo(): { id: number; nome: string } | null {
  try { return JSON.parse(localStorage.getItem('mot_info') || 'null') } catch { return null }
}

export function logoutMotorista() {
  localStorage.removeItem('mot_token')
  localStorage.removeItem('mot_info')
  window.location.href = '/m/entregador'
}

// ===================== FILA OFFLINE (outbox) =====================
// Ações de campo (entrega/check-in/check-out/aceite) feitas sem internet ficam
// numa fila no aparelho e são reenviadas sozinhas quando o sinal volta.
const OUTBOX_KEY = 'mot_outbox'
const read = (): any[] => { try { return JSON.parse(localStorage.getItem(OUTBOX_KEY) || '[]') } catch { return [] } }
const write = (a: any[]) => localStorage.setItem(OUTBOX_KEY, JSON.stringify(a))
export const outboxCount = () => read().length
const enqueue = (item: any) => { const a = read(); a.push({ ...item, _id: Date.now() + Math.random() }); write(a) }
const isOffline = (e: any) => !e?.response // sem resposta = rede caiu (offline)

const fileToB64 = (f: File): Promise<string> => new Promise((res, rej) => {
  const r = new FileReader(); r.onload = () => res(String(r.result)); r.onerror = rej; r.readAsDataURL(f)
})
function b64ToBlob(dataUrl: string): Blob {
  const [meta, b64] = dataUrl.split(','); const mime = (meta.match(/:(.*?);/) || [])[1] || 'image/jpeg'
  const bin = atob(b64); const u = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i)
  return new Blob([u], { type: mime })
}

// Confirma entrega (tenta online; offline → enfileira com a foto em base64).
export async function confirmarEntrega(payload: any, foto?: File | null) {
  try {
    const { data } = await motApi.post('/entregas', payload)
    if (foto) { const fd = new FormData(); fd.append('file', foto); await motApi.post(`/entregas/${data.id}/foto`, fd) }
    return { online: true, data }
  } catch (e: any) {
    if (!isOffline(e)) throw e
    enqueue({ kind: 'entrega', payload, fotoB64: foto ? await fileToB64(foto) : null })
    return { online: false }
  }
}

// Ação simples (checkin/checkout/aceitar-romaneio). Offline → enfileira.
export async function acaoEntregador(url: string, body: any) {
  try { const { data } = await motApi.post(url, body); return { online: true, data } }
  catch (e: any) { if (!isOffline(e)) throw e; enqueue({ kind: 'simple', url, body }); return { online: false } }
}

let flushing = false
export async function flushOutbox(): Promise<number> {
  if (flushing || !navigator.onLine) return 0
  const a = read(); if (!a.length) return 0
  flushing = true
  const rest: any[] = []
  for (const it of a) {
    try {
      if (it.kind === 'simple') await motApi.post(it.url, it.body)
      else if (it.kind === 'entrega') {
        const { data } = await motApi.post('/entregas', it.payload)
        if (it.fotoB64) { const fd = new FormData(); fd.append('file', b64ToBlob(it.fotoB64), 'foto.jpg'); await motApi.post(`/entregas/${data.id}/foto`, fd) }
      }
    } catch (e: any) {
      if (isOffline(e) || (e?.response?.status >= 500)) rest.push(it) // mantém p/ tentar depois
      // 4xx (ex. dado inválido): descarta pra não travar a fila
    }
  }
  write(rest); flushing = false
  return a.length - rest.length
}

if (typeof window !== 'undefined') {
  window.addEventListener('online', () => { flushOutbox() })
  setInterval(() => { if (navigator.onLine) flushOutbox() }, 20000)
}
